"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseServiceImpl = void 0;
var Utils_1 = require("../utils/Utils");
var CourseProviderImpl_1 = require("./provider/firebase/CourseProviderImpl");
var CourseProviderImpl_2 = require("./provider/airabbi/CourseProviderImpl");
var CourseServiceImpl = (function () {
    function CourseServiceImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " CourseServiceImpl#")], args, false));
            }
        };
        this.log('CourseServiceImpl# created!');
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new CourseProviderImpl_1.CourseProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new CourseProviderImpl_2.CourseProviderImpl(cfg);
                break;
        }
    }
    CourseServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return this.provider.init(env);
    };
    CourseServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    CourseServiceImpl.prototype.createCourse = function (course) {
        return this.provider.createCourse(course);
    };
    CourseServiceImpl.prototype.syncExerciseIntoCourses = function (exercise) {
        return this.provider.syncExerciseIntoCourses(exercise);
    };
    CourseServiceImpl.prototype.getAllCoursesFromLocal = function () {
        return [];
    };
    CourseServiceImpl.prototype.getMyUnitCourses = function () {
        return this.provider.getMyUnitCourses();
    };
    CourseServiceImpl.prototype.getCourses = function () {
        return this.provider.getCourses();
    };
    CourseServiceImpl.prototype.getCourseByCid = function (cid) {
        return this.provider.getCourseByCid(cid);
    };
    CourseServiceImpl.prototype.getTests = function (uid) {
        return this.provider.getTests(uid);
    };
    CourseServiceImpl.prototype.getMyTestsByPagination = function (codeType, skip, limit, sort, searchString) {
        return this.provider.getMyTestsByPagination(codeType, skip, limit, sort, searchString);
    };
    CourseServiceImpl.prototype.getCourse = function (id, isGlobalTest) {
        return this.provider.getCourse(id, isGlobalTest);
    };
    CourseServiceImpl.prototype.getCourseByUnit = function (id, unit) {
        return this.provider.getCourseByUnit(id, unit);
    };
    CourseServiceImpl.prototype.removeCourse = function (id) {
        return this.provider.removeCourse(id);
    };
    CourseServiceImpl.prototype.removeShareCourse = function (id, shareType) {
        return this.provider.removeShareCourse(id, shareType);
    };
    CourseServiceImpl.prototype.removeUnitCourse = function (unit, id) {
        return this.provider.removeUnitCourse(unit, id);
    };
    CourseServiceImpl.prototype.updateCourse = function (course) {
        return this.provider.updateCourse(course);
    };
    CourseServiceImpl.prototype.getMyCourses = function () {
        return this.provider.getMyCourses();
    };
    CourseServiceImpl.prototype.searchCourse = function (filter) {
        return this.provider.searchCourse(filter);
    };
    CourseServiceImpl.prototype.getStudentStatsByOnlineExercises = function (courseId, studentId) {
        return this.provider.getStudentStatsByOnlineExercises(courseId, studentId);
    };
    CourseServiceImpl.prototype.getStudentStats = function (courseId, studentId) {
        return this.provider.getStudentStats(courseId, studentId);
    };
    CourseServiceImpl.prototype.updateProperty = function (id, propName, value) {
        return this.provider.updateProperty(id, propName, value);
    };
    CourseServiceImpl.prototype.getStudentStatusList = function (courseId, lessonId, exerciseId) {
        return this.provider.getStudentStatusList(courseId, lessonId, exerciseId);
    };
    CourseServiceImpl.prototype.getStudentStatusByCourseWithSpecificExerciseIds = function (courseId, lessonId, exerciseIds, uid) {
        return this.provider.getStudentStatusByCourseWithSpecificExerciseIds(courseId, lessonId, exerciseIds, uid);
    };
    CourseServiceImpl.prototype.getStudentStatus = function (courseId, lessonId, exerciseId, uid, useChatGPT) {
        return this.provider.getStudentStatus(courseId, lessonId, exerciseId, uid, useChatGPT);
    };
    CourseServiceImpl.prototype.getLessonExerciseStatus = function (courseId, lessonId) {
        return this.provider.getLessonExerciseStatus(courseId, lessonId);
    };
    CourseServiceImpl.prototype.getCourseExerciseStatus = function (courseId) {
        return this.provider.getCourseExerciseStatus(courseId);
    };
    CourseServiceImpl.prototype.getStudentStatusByCourse = function (courseId, unit) {
        return this.provider.getStudentStatusByCourse(courseId, unit);
    };
    CourseServiceImpl.prototype.getOwnStudentStatusByCourse = function (courseId) {
        return this.provider.getOwnStudentStatusByCourse(courseId);
    };
    CourseServiceImpl.prototype.listenVideoConference = function (listener) {
        return this.provider.listenVideoConference(listener);
    };
    CourseServiceImpl.prototype.setupVideoConference = function (courseId, meetingNumber, meetingPassword, courseObj) {
        if (courseObj === void 0) { courseObj = {}; }
        return this.provider.setupVideoConference(courseId, meetingNumber, meetingPassword, courseObj);
    };
    CourseServiceImpl.prototype.endVideoConference = function (courseId) {
        return this.provider.endVideoConference(courseId);
    };
    CourseServiceImpl.prototype.getVideoConferenceInfos = function () {
        return this.provider.getVideoConferenceInfos();
    };
    CourseServiceImpl.prototype.listenAllStudentStatus = function (courseId, lessonId, exerciseId, listener) {
        return this.provider.listenAllStudentStatus(courseId, lessonId, exerciseId, listener);
    };
    CourseServiceImpl.prototype.listenStudentStatus = function (courseId, lessonId, exerciseId, userId, listener) {
        return this.provider.listenStudentStatus(courseId, lessonId, exerciseId, userId, listener);
    };
    CourseServiceImpl.prototype.startExercise = function (courseId, lessonId, exerciseId, user, useChatGPT) {
        return this.provider.startExercise(courseId, lessonId, exerciseId, user, useChatGPT);
    };
    CourseServiceImpl.prototype.stopCurrentExercise = function () {
        return this.provider.stopCurrentExercise();
    };
    CourseServiceImpl.prototype.stopTask = function (courseId, lessonId, exerciseId, userId) {
        return this.provider.stopTask(courseId, lessonId, exerciseId, userId);
    };
    CourseServiceImpl.prototype.getAvailableKernels = function () {
        return this.provider.getAvailableKernels();
    };
    CourseServiceImpl.prototype.getCurrentExercise = function () {
        return this.provider.getCurrentExercise();
    };
    CourseServiceImpl.prototype.submitCode = function (courseId, lessonId, exerciseId, uid, code, vds, kernel, submitType, version, stepId, codeType, originalTestId, originalExerciseId, isGlobalTest) {
        if (stepId === void 0) { stepId = ''; }
        if (codeType === void 0) { codeType = ''; }
        return this.provider.submitCode(courseId, lessonId, exerciseId, uid, code, vds, kernel, submitType, version, stepId, codeType, originalTestId, originalExerciseId, isGlobalTest);
    };
    CourseServiceImpl.prototype.moveCurrentCodeToStudentStatus = function () {
        return this.provider.moveCurrentCodeToStudentStatus();
    };
    CourseServiceImpl.prototype.sendInput = function (userId, input) {
        return this.provider.sendInput(userId, input);
    };
    CourseServiceImpl.prototype.readTip = function (courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, tipIndex, tip) {
        return this.provider.readTip(courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, tipIndex, tip);
    };
    CourseServiceImpl.prototype.readAnswer = function (courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, ansIndex, answer) {
        return this.provider.readAnswer(courseId, lessonId, exerciseId, user, lessonIndex, exerciseIndex, ansIndex, answer);
    };
    CourseServiceImpl.prototype.setShowExerciseAnswer = function (courseId, lessonIndex, exerciseIndex, isShowAnswer, isOffline) {
        return this.provider.setShowExerciseAnswer(courseId, lessonIndex, exerciseIndex, isShowAnswer, isOffline);
    };
    CourseServiceImpl.prototype.setShowExerciseContent = function (courseId, lessonIndex, exerciseIndex, exerciseId, isShowContent, isOffline) {
        return this.provider.setShowExerciseContent(courseId, lessonIndex, exerciseIndex, exerciseId, isShowContent, isOffline);
    };
    CourseServiceImpl.prototype.setShowExerciseTip = function (courseId, lessonIndex, exerciseIndex, isShowTip, isOffline) {
        return this.provider.setShowExerciseTip(courseId, lessonIndex, exerciseIndex, isShowTip, isOffline);
    };
    CourseServiceImpl.prototype.incrementDuration = function (courseId, lessonId, exerciseId, userId, offset) {
        return this.provider.incrementDuration(courseId, lessonId, exerciseId, userId, offset);
    };
    CourseServiceImpl.prototype.saveCode = function (courseId, lessonId, exerciseId, userId, code) {
        return this.provider.saveCode(courseId, lessonId, exerciseId, userId, code);
    };
    CourseServiceImpl.prototype.listenLesson = function (courseId, lessonId, listener) {
        return this.provider.listenLesson(courseId, lessonId, listener);
    };
    CourseServiceImpl.prototype.listenCode = function (courseId, lessonId, exerciseId, userId, listener) {
        return this.provider.listenCode(courseId, lessonId, exerciseId, userId, listener);
    };
    CourseServiceImpl.prototype.observeThisStudent = function (courseId, lessonId, exerciseId, userId, observed) {
        return this.provider.observeThisStudent(courseId, lessonId, exerciseId, userId, observed);
    };
    CourseServiceImpl.prototype.updateDuration = function (courseId, lessonId, exerciseId, userId) {
        return this.provider.updateDuration(courseId, lessonId, exerciseId, userId);
    };
    CourseServiceImpl.prototype.createComment = function (courseId, lessonId, teacherId, studentId, content) {
        return this.provider.createComment(courseId, lessonId, teacherId, studentId, content);
    };
    CourseServiceImpl.prototype.updateComment = function (courseId, lessonId, teacherId, studentId, content) {
        return this.provider.updateComment(courseId, lessonId, teacherId, studentId, content);
    };
    CourseServiceImpl.prototype.removeComment = function (courseId, lessonId, studentId) {
        return this.provider.removeComment(courseId, lessonId, studentId);
    };
    CourseServiceImpl.prototype.getComment = function (courseId, lessonId, studentId) {
        return this.provider.getComment(courseId, lessonId, studentId);
    };
    CourseServiceImpl.prototype.getComments = function (courseId, lessonId) {
        return this.provider.getComments(courseId, lessonId);
    };
    CourseServiceImpl.prototype.openResourceFolder = function () {
        return this.provider.openResourceFolder();
    };
    CourseServiceImpl.prototype.createMaterial = function (codeType, title, url) {
        return this.provider.createMaterial(codeType, title, url);
    };
    CourseServiceImpl.prototype.updateMaterial = function (material, shareType, internalTeacherResourceUid) {
        return this.provider.updateMaterial(material, shareType, internalTeacherResourceUid);
    };
    CourseServiceImpl.prototype.deleteMaterial = function (id) {
        return this.provider.deleteMaterial(id);
    };
    CourseServiceImpl.prototype.deleteShareMaterial = function (id, shareType) {
        return this.provider.deleteShareMaterial(id, shareType);
    };
    CourseServiceImpl.prototype.getMaterialUploadUrl = function () {
        return this.provider.getMaterialUploadUrl();
    };
    CourseServiceImpl.prototype.getMaterials = function (codeType, uid) {
        return this.provider.getMaterials(codeType, uid);
    };
    CourseServiceImpl.prototype.getMyMaterialsByPagination = function (codeType, skip, limit, sort, searchString) {
        return this.provider.getMyMaterialsByPagination(codeType, skip, limit, sort, searchString);
    };
    CourseServiceImpl.prototype.getSharedMaterials = function (codeType, sharedType, uid) {
        return this.provider.getSharedMaterials(codeType, sharedType, uid);
    };
    CourseServiceImpl.prototype.shareMaterial = function (materialObj, sharedType) {
        return this.provider.shareMaterial(materialObj, sharedType);
    };
    CourseServiceImpl.prototype.cloneSharedMaterial = function (sharedType, materialId) {
        return this.provider.cloneSharedMaterial(sharedType, materialId);
    };
    CourseServiceImpl.prototype.setExerciseArchived = function (courseId, lessonId, exerciseId, archived) {
        return this.provider.setExerciseArchived(courseId, lessonId, exerciseId, archived);
    };
    CourseServiceImpl.prototype.setExerciseLiked = function (courseId, lessonId, exerciseId, liked) {
        return this.provider.setExerciseLiked(courseId, lessonId, exerciseId, liked);
    };
    CourseServiceImpl.prototype.removeUser = function (uid) {
        return this.provider.removeUser(uid);
    };
    CourseServiceImpl.prototype.updateUser = function (user) {
        return this.provider.updateUser(user);
    };
    CourseServiceImpl.prototype.getSharedTests = function (codeType, sharedType, uid) {
        return this.provider.getSharedTests(codeType, sharedType, uid);
    };
    CourseServiceImpl.prototype.shareTest = function (testObj, sharedType) {
        return this.provider.shareTest(testObj, sharedType);
    };
    CourseServiceImpl.prototype.cloneSharedTest = function (sharedType, testId) {
        return this.provider.cloneSharedTest(sharedType, testId);
    };
    CourseServiceImpl.prototype.createTest = function (test) {
        return this.provider.createTest(test);
    };
    CourseServiceImpl.prototype.getStudentCourse = function (uid) {
        return this.provider.getStudentCourse(uid);
    };
    CourseServiceImpl.prototype.getStudentImportTemplateUrl = function () {
        return this.provider.getStudentImportTemplateUrl();
    };
    CourseServiceImpl.prototype.joinCourseByCid = function (cid, student, seatNo) {
        return this.provider.joinCourseByCid(cid, student, seatNo);
    };
    CourseServiceImpl.prototype.removeStudentFromCourse = function (courseId, uid) {
        return this.provider.removeStudentFromCourse(courseId, uid);
    };
    CourseServiceImpl.prototype.setAddByCode = function (courseId, enabled) {
        return this.provider.setAddByCode(courseId, enabled);
    };
    CourseServiceImpl.prototype.updateSeatNoInCourse = function (courseId, uid, seatNo) {
        return this.provider.updateSeatNoInCourse(courseId, uid, seatNo);
    };
    CourseServiceImpl.prototype.updateTest = function (test) {
        return this.provider.updateTest(test);
    };
    CourseServiceImpl.prototype.removeTest = function (test) {
        return this.provider.removeTest(test);
    };
    CourseServiceImpl.prototype.removeShareTest = function (test, shareType) {
        return this.provider.removeShareTest(test, shareType);
    };
    CourseServiceImpl.prototype.listenTest = function (courseId, testId, listener) {
        return this.provider.listenTest(courseId, testId, listener);
    };
    CourseServiceImpl.prototype.resetTestExerciseStatus = function (courseId, testId, exerciseId) {
        return this.provider.resetTestExerciseStatus(courseId, testId, exerciseId);
    };
    CourseServiceImpl.prototype.unlistenCode = function (courseId, lessonId, exerciseId, userId) {
        return this.provider.unlistenCode(courseId, lessonId, exerciseId, userId);
    };
    CourseServiceImpl.prototype.unlistenTest = function (courseId, testId) {
        return this.provider.unlistenTest(courseId, testId);
    };
    CourseServiceImpl.prototype.removeCodeListener = function () {
        return this.provider.removeCodeListener();
    };
    CourseServiceImpl.prototype.removeTestListener = function () {
        return this.provider.removeTestListener();
    };
    CourseServiceImpl.prototype.readCode = function (courseId, lessonId, exerciseId, userId) {
        return this.provider.readCode(courseId, lessonId, exerciseId, userId);
    };
    CourseServiceImpl.prototype.getTestExerciseStatus = function (courseId, testId) {
        return this.provider.getTestExerciseStatus(courseId, testId);
    };
    CourseServiceImpl.prototype.getSharedCourses = function (codeType, sharedType, uid) {
        return this.provider.getSharedCourses(codeType, sharedType, uid);
    };
    CourseServiceImpl.prototype.shareCourse = function (courseObj, sharedType) {
        return this.provider.shareCourse(courseObj, sharedType);
    };
    CourseServiceImpl.prototype.cloneSharedCourse = function (sharedType, courseId, teacher) {
        return this.provider.cloneSharedCourse(sharedType, courseId, teacher);
    };
    CourseServiceImpl.prototype.cloneCourse = function (srcUnit, srcCourseId, teacher) {
        return this.provider.cloneCourse(srcUnit, srcCourseId, teacher);
    };
    CourseServiceImpl.prototype.isCourseExisted = function (unit, courseId, uid) {
        return this.provider.isCourseExisted(unit, courseId, uid);
    };
    CourseServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    CourseServiceImpl.prototype.getLintConfig = function (codeType) {
        return this.provider.getLintConfig(codeType);
    };
    CourseServiceImpl.prototype.inspect = function (code, codeType) {
        return this.provider.inspect(code, codeType);
    };
    CourseServiceImpl.prototype.getCoursesByUnit = function (unit) {
        return this.provider.getCoursesByUnit(unit);
    };
    CourseServiceImpl.prototype.getMyUnitCoursesByPagination = function (sort, skip, limit, searchString, classType) {
        return this.provider.getMyUnitCoursesByPagination(sort, skip, limit, searchString, classType);
    };
    CourseServiceImpl.prototype.getCoursesByUnitByPagination = function (unit, sort, skip, limit, searchString) {
        return this.provider.getCoursesByUnitByPagination(unit, sort, skip, limit, searchString);
    };
    CourseServiceImpl.prototype.getAllCoursesByPagination = function (sort, skip, limit, searchString) {
        return this.provider.getAllCoursesByPagination(sort, skip, limit, searchString);
    };
    CourseServiceImpl.prototype.fetchAllCoursesByStudent = function (email, sortBy, projection) {
        return this.provider.fetchAllCoursesByStudent(email, sortBy, projection);
    };
    CourseServiceImpl.prototype.updatedStudentStatus = function (courseId, lessonId, exerciseId, codeStatus) {
        return this.provider.updatedStudentStatus(courseId, lessonId, exerciseId, codeStatus);
    };
    CourseServiceImpl.prototype.updateStudentCodeStatus = function (courseId, lessonId, exerciseId, code, codeStatus, status, stepId) {
        return this.provider.updateStudentCodeStatus(courseId, lessonId, exerciseId, code, codeStatus, status, stepId);
    };
    CourseServiceImpl.prototype.getDesktopKernel = function () {
        return this.provider.getDesktopKernel();
    };
    CourseServiceImpl.prototype.syncExerciseIntoTests = function (exercise) {
        return this.provider.syncExerciseIntoTests(exercise);
    };
    CourseServiceImpl.prototype.loadGPTMessage = function (sessionId) {
        return this.provider.loadGPTMessage(sessionId);
    };
    CourseServiceImpl.prototype.insertGPTMessage = function (sessionId, message) {
        return this.provider.insertGPTMessage(sessionId, message);
    };
    return CourseServiceImpl;
}());
exports.CourseServiceImpl = CourseServiceImpl;
//# sourceMappingURL=CourseServiceImpl.js.map